import {BaseApi} from '@/common/api/BaseApi';
import {ApiProperties, ApiVersionProperties} from '@/types/common/api/api.types';

export class CustomerApi {

  public static api({id, version = 'v1'}: ApiProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/customer${id !== undefined ? `/${id}` : ''}`;
  }

  public static modules({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${this.api({version})}/modules`;
  }

  public static verifyName({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${this.api({version})}/verify-name`;
  }

  public static verifyUrl({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${this.api({version})}/verify-url`;
  }

  public static verifyEmail({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${this.api({version})}/verify-email`;
  }

  public static resetPassword({id, version = 'v1'}: ApiProperties = {}): string {
    return `${this.api({version})}/${id}/reset-password`;
  }

  public static migrate({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${this.api({version})}/migrate`;
  }

  public static style({subdomain, version = 'v1'}: { subdomain: string; version?: string }): string {
    return `${this.api({version})}/style?subdomain=${encodeURIComponent(subdomain)}`;
  }

  // L-6 — production browsers send a Referer, so the backend resolves the
  // tenant from there and no URL parameter is needed (keeps the tenant out
  // of access logs / browser history).
  public static styleByReferer({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${this.api({version})}/style`;
  }
}
